import {Component, ElementRef, ViewChild} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HeaderComponent} from './dashboard/header/header.component';
import {FooterComponent} from './dashboard/footer/footer.component';
import { LoadingComponent } from '../util/component/loading/loading.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoadingComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'baazar-landing';

  @ViewChild('footerRef', {static: false}) footer!: ElementRef;

  scrollToFooter(): void {
    const footerElement = document.getElementById('footer');
    if (footerElement) {
      footerElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }
}
